import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useRef, useState } from "react";
import Pagination from "../../common/pagination/pagination";
import { apiRequest } from "../../../infrastructure/backendService";
import { ClipLoader } from "react-spinners";

const StyledTable = styled(Table)(({ theme }) => ({
  borderRadius: "8px",
  borderCollapse: "collapse", // Collapse borders to avoid doubled borders between cells
}));
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  position: "relative",
  overflow: "auto",
  paddingBottom: "4px",
  borderRadius: "12px",
  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    paddingTop: "10px",
    paddingRight: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#F2BE22", // Scrollbar color
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-corner": {
    backgroundColor: "transparent",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: " #FEBE00",
    fontWeight: "700",
    color: "#000",
    textAlign: "left",
    border: "1px solid #fff",
    padding: "10px",
    margin: "10px",
    whiteSpace:"nowrap",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // whiteSpace: "pre-line",
    whiteSpace: "nowrap",
    textOrientation: "mixed", // Allows for upright text within vertical writing mode
    textAlign: "left",
    margin: 0,
    padding: "10px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  //   height: "-10px",
  "& td, & th": {
    margin: "10px",
    padding: "10px",
    border: "1px solid #fff",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "#FFECB4", // Set odd rows to white
  },
  "&:nth-of-type(odd)": {
    backgroundColor: " #fff", // Set even rows to yellow
  },
}));

const MailingLabelsTableData = (props:any) => {  
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(0);
  const [tableHeaders, setTableHeaders] = useState<any>(props.tableHeaders)
  const [reportData, setReportData] = useState<any>(props.ReportData)
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    setTableHeaders(props.tableHeaders)
    setReportData(props.ReportData)
  },[props])

  const prevPageNumber = usePrevious(pageNumber);
  useEffect(() => {
    if(props.reportName === 'Devotee Report' || props.reportName === 'Devotees and Zipcode' || props.reportName === 'Mailing Labels'){
      setTotalRecords(props?.totalElements);
      setPageSize(props?.pageSize)
    }
  }, [])

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current; // Return previous value (before update)
  }
  useEffect(() => {
    if ((prevPageNumber !== undefined && prevPageNumber !== pageNumber)) {
      if(props.reportName === 'Devotee Report'){
        handleDevoteeReport()
      }else if(props.reportName === 'Devotees and Zipcode'){
        handleZipcodeReport()
      }else if(props.reportName === 'Mailing Labels'){
        handleMailingLabelsApi()
      }
    }
  }, [pageNumber, prevPageNumber]);

  const handleDevoteeReport = async () => {
    let reqBody = props.requestBodyDrillDown
    reqBody.pageNumber = pageNumber
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/devotee/DEVOTEE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        setTotalRecords(res?.data[0]?.totalElements);
        setPageSize(res?.data[0]?.pagesize)
        // let counter = 1;
        const getFormattedAddress = (address:any, city:any, state:any, country:any, zipcode:any) => {
          const parts = [address, city, state, country, zipcode].filter(Boolean);
          return parts.length > 0 ? parts.join(' ') : '-';
        };
        const getFormattedName = (firstname:any, middlename:any, lastname:any) => {
          const parts = [firstname, middlename, lastname].filter(Boolean);
          return parts.length > 0 ? parts.join(' ') : '-';
        };
        const response = res.data[0].data.map((item: any,index:number) => {
          return {
            "Serial Number": index + 1 + (pageNumber - 1) * pageSize,
            "Name": getFormattedName(item.firstname, item.middlename, item.lastname),
            "Address": getFormattedAddress(item.address, item.city, item.state, item.country, item.zipcode),
            "Sign-in Name": item.username || '-',
            "Home Phone": item.phoneresidence || '-',
            "Work Phone": item.phonework || '-',
            "Email": item.email || '-',
            "Preferred Language": item.preferredlanguage || '-',
            "Date of Birth": item.dateofbirth || '-',
          }
        })
        setReportData(response)
      })
      .catch((err) => {
        setLoading(false);
      });
  }; 
  const handleZipcodeReport = async () => {
    let reqBody = props.requestBodyDrillDown
    reqBody.pageNumber = pageNumber
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/devotee/NUMBER_OF_DEVOTEES_AND_ZIPCODE_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        setTotalRecords(res?.data[0]?.totalElements);
        setPageSize(res?.data[0]?.pagesize)
        const response = res.data[0].data.map((item: any) => {
          return {
            "Number of Devotees":item.usercount,
            "Zipcode": item.zipcode,
            "City": item.city,
            "State": item.state,
            "Country": item.country,
          }
        })
        setReportData(response)
      })
      .catch((err) => {
        setLoading(false);
      });
  }; 
  const handleMailingLabelsApi = async () => {
    let reqBody = props.requestBodyDrillDown
    reqBody.pageNumber = pageNumber
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/devotee/MAILING_LABELS/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        setTotalRecords(res?.data[0]?.totalElements);
        setPageSize(res?.data[0]?.pagesize)
        const response = res.data[0].data.map((obj: any,index:number) => {
          return {
            "Sr.No.":index + 1 + (pageNumber - 1) * pageSize,
            "Sign-in Name": obj.username,
            "First Name": obj.firstname || "--",
            "Middle Name": obj.middlename || "--",
            "Last Name": obj.lastname || "--",
            Address: obj.address,
            City: obj.city,
            State: obj.state,
            "Zip code": obj.zipcode,
            Country: obj.country,
          };
        })
        setReportData(response)
      })
      .catch((err) => {
        setLoading(false);
      });
  }; 
    return (
        <>
        {loading && (
            <div style={{ position: 'sticky', top: '50%', zIndex: '999', textAlign: 'center' }}>
              <ClipLoader color="#000" loading={loading} size={25} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
              </span>
            </div>
        )}
        {reportData.length === 0 && 
          <Typography sx={{margin:"24px auto",color:"red",fontSize:"28px"}}>
          <b>No Records found</b>
          </Typography>
          }
          <StyledTableContainer sx={{ width: "100%" }}>
            <StyledTable aria-label="customized table">
              <TableHead>
                <TableRow>
                  {reportData.length > 0 && Object.values(tableHeaders).map((header: any) => (
                    <StyledTableCell align="center" key={header}>
                      <div style={{textTransform:"capitalize",alignItems:"flex-start"}} dangerouslySetInnerHTML={{ __html: header }} />
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((item:any, index:any) => (
                 <StyledTableRow key={index}>
                    {Object.keys(tableHeaders).map((column) => (
                      <StyledTableCell key={column}>
                        <div dangerouslySetInnerHTML={{ __html: item[column] }} />
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                ))}
              </TableBody>
            </StyledTable>
          </StyledTableContainer>
          
      {totalRecords > pageSize ? (
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "10px",
            marginTop: "3px",
          }}
        >
          <Pagination
            items={totalRecords}
            itemsPerPage={pageSize}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
      ) : (
        ""
      )}
        </>
      );
};

export default MailingLabelsTableData;